import React, {useState} from 'react';
import Markdown from "marked-react";

export function Risk({codeRisque, content, dept, com}) {

    const [result, setResult] = useState("");
    const [loading, setLoading] = useState(false);

    const handleRefresh = () => {
        setLoading(true);
        let url = (com && content === 'description') ? `/api/risques/${codeRisque}/${content}/com/${com}` : `/api/risques/${codeRisque}/${content}/dept/${dept}`;
        fetch(url)
            .then(res => {
                if (!res.ok) {
                    return Promise.reject(res);
                }
                return res.text();
            })
            .then(completion => {
                setResult(completion);
            })
            .catch(error => {
                console.error('Failed to perform completion', error);
                setResult("ERREUR");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // TODO parameters: length, user context/prompt, ...

    return (
        <div>
            {/*
            <h2>Risk: {codeRisque} / {content} / {dept} / {com}</h2>
            */}
            <p>Testez les API génératives du Prev'hub !</p>
            <button onClick={handleRefresh} disabled={loading} className="btn btn-dark">Générer</button>
            <div style={{ outline: '1px solid black', margin: 5, padding: 5}}>
                {loading ? (<span>Chargement...</span>) : (<Markdown>{result}</Markdown>)}
            </div>
        </div>
    )
}